import { render, staticRenderFns } from "./visits.vue?vue&type=template&id=3ba37ae9&scoped=true"
import script from "./visits.vue?vue&type=script&lang=js"
export * from "./visits.vue?vue&type=script&lang=js"
import style0 from "./visits.vue?vue&type=style&index=0&id=3ba37ae9&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba37ae9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ba37ae9')) {
      api.createRecord('3ba37ae9', component.options)
    } else {
      api.reload('3ba37ae9', component.options)
    }
    module.hot.accept("./visits.vue?vue&type=template&id=3ba37ae9&scoped=true", function () {
      api.rerender('3ba37ae9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/admin/visits.vue"
export default component.exports